import React, { useState, Fragment, useEffect } from 'react';
import Img from "../../images/mail.png";
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux"
import { clearErrors, forgotPasswordAction } from "../../../redux/actions/userActions"
import Loader from '../../loader/loader';
import { FORGET_PASSWORD_RESET } from '../../../redux/constants/userConstants';
import usePageMeta from '../../../hooks/usePageMeta';

const VerifyEmail = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { loading, error, message, } = useSelector((state) => state.forgotPassword);
    const { isAuthenticated } = useSelector((state) => state.verifyEmailStore);

    const [email, setEmail] = useState("")

    usePageMeta("forgotPassword");

    useEffect(() => {

        setEmail(localStorage.getItem("email"))

    }, [])




    const resend = (e) => {
        if (!email) {
            toast.error("Credentials lost please forgot the password again")
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            toast.error("Please enter a valid email address");
            return;
        }


        const userData = {
            email,
        }

        dispatch(forgotPasswordAction(userData))
    }


    useEffect(() => {
        if (error) {
            toast.error(error)
            dispatch(clearErrors())
        }

        if (message) {
            toast.info(message)
            dispatch({ type: FORGET_PASSWORD_RESET })
        }

        if (isAuthenticated) {
            navigate('/')
        }

    }, [error, message, dispatch, isAuthenticated, navigate])

    return (
        <Fragment>
            {loading ? <Loader /> :
                <section className="flex-center min-h-[100vh] w-full">
                    <div className="flex-center flex-col">
                        <img src={Img} alt="email" className="w-[13vmax]" />

                        <h4 className="text-[3vmax] lg:text-[1.8vmax]  font-3 font-bold">
                            <span   >Reset your</span> <span className="text-[var(--color-2)]">Password</span></h4>
                        <p className="pt-[0.7vmax] text-[1.8vmax] lg:text-[1.1vmax] text-center">
                            We've sent a code to{" "}
                            <br className='md:hidden' />

                            <span className="font-extrabold  text-[2vmax] lg:text-[1.2vmax]">&nbsp;{email}</span>
                        </p>
                        <h5 className='text-[1.8vmax] pt-[2vmax] lg:pt-0 lg:text-[1.1vmax] ' >Open the link and reset your password</h5>
                        <br />
                        <div className="resendEmail text-[2vmax] lg:text-[1.2vmax] ">
                            Didn't get the code?{" "}
                            <button className="text-[var(--color-2)] font-bold" onClick={resend}>
                                Click to Resend
                            </button>
                        </div>

                    </div>
                </section>
            }
        </Fragment>

    );
};

export default VerifyEmail;
